<div class="container">
  <form [formGroup]="phoneForm" >
    <div class="row-form">
      <app-simple-string-value-accessor label="Telefon"
                                        formControlName="phone"
                                        required="true"></app-simple-string-value-accessor>
      <app-simple-select-value-accessor label="Status"
                                        formControlName="statusId"
                                        [data]="statuses"
                                        required="true"></app-simple-select-value-accessor>
    </div>
  </form>
  <div class="actions">
    <button mat-raised-button
            action-button
            class="width-100 action-button"
            [disabled]="phoneForm.invalid"
            color="primary"
            type="button"
            [action]="editPhone.bind(this)">
      Edytuj telefon
    </button>
    <button mat-stroked-button
            class="width-100 action-button"
            color="primary"
            type="button"
            (click)="deletePhone()">
      Usuń
    </button>
  </div>
</div>
